import {
  financialMetricsSummaryResponse,
  GetCalculatedFinbox,
} from "@/services/api/finbox-endpoints";
import { GetCoverage } from "@/services/api/user-endpoints";
import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import { useState, useEffect } from "react";
import { coverageResponse } from "@/models/equip-api-response-objects/coverageResponse";
import FinancialMetricsSummary from "./compareSubmissionBox";


export default function ModelInfo(props: { companyId: string }) {
  const [companyInfo, setCompanyInfo] = useState<coverageResponse>();
  const [finBoxes, setFinBoxes] = useState<financialMetricsSummaryResponse[]>([]);

  useEffect(() => {
    const getData = async () => {
      const compInfo = await GetCoverage();
      if (compInfo == null) return;

      var theCompany = compInfo.find((infos) => infos.companyId == props.companyId);
      if (theCompany == null) return;

      setCompanyInfo(theCompany);

      const finBoxWip = await GetCalculatedFinbox(
        "compare_submission",
        theCompany.ric,
        undefined,
        "WIP".toLowerCase()
      );
      const finBoxLive = await GetCalculatedFinbox(
        "compare_submission",
        theCompany.ric,
        undefined,
        "LIVE"
      );
      setFinBoxes([finBoxWip, finBoxLive]);
    };
    getData();
  }, []);

  return (
    <Stack spacing={1}>
      {companyInfo != undefined && (
        <Box mb={2}>
          <Typography variant="body2" color="text.secondary" fontWeight={600}>
            {companyInfo.description}
          </Typography>
          <Typography variant="body2" color="text.secondary" fontWeight={600}>
            {companyInfo.ric}
          </Typography>
        </Box>
      )}

      {finBoxes[0] && (
        <Box>
          <Typography variant="body2" color="text.secondary" mb={0}>
            WIP Metrics
          </Typography>
          <FinancialMetricsSummary data={finBoxes[0]} />
        </Box>
      )}
      {finBoxes[1] && (
        <Box>
          <Typography variant="body2" color="text.secondary" mb={0}>
            Live Metrics
          </Typography>
          <FinancialMetricsSummary data={finBoxes[1]} />
        </Box>
      )}
    </Stack>
  );
}
